export const environment = {
  production: true,
  environment: 'prod',
  locale: 'en_US',
  businessId: 'BUSID',
  apiServerUrlPlatformClient: '',
  //crossSiteScriptingRegex: /\00|<|\+ADw-|>|\+AD4-|%25|\(\s*[a-z]{2,}\.[a-z]{2,}.*\)/g,

  api: {
    headers: {
      countryCode: 'US',
      businessCode: 'CRS',
      channelId: 'CRSDESKTOP',
      client_id: '09e2bc9e-482d-4713-8934-a60cb5168f40'
    },
    path: 'gcgapi/prod/',
    endpoints: {
      'contentServicePageDefUrl': 'content/subBusinessID/{BUSID}/applicationID/CARDS/viewID/{PAGEDEF}?isStaticRequired=true',
      'contentServiceBrandingUrl': 'content/subBusinessID/{BUSID}/applicationID/CARDS/contentType/cmcomponent/viewID/cmpnt_svc_cw_branding_primary?isStaticRequired=true',
      'contentServiceConfigUrl': 'content/subBusinessID/{BUSID}/applicationID/CARDS/contentType/config/viewID/cfg_cw_app_client_settings?isStaticRequired=true',
      'ngaSignOn/submission': '/RSnextgen/svc/launch/NGASignOnRedirect.action',
      'signOnDataURL': '/RSnextgen/svc/launch/NGASignOnPageRedirect.action',
      'honeyPotTokenURL': '/RSnextgen/svc/launch/generateHPToken.action',
      'koreServiceJwt': 'api/users/chatBot/koreServices/tokenAndUserInfo/retrieve',
      'KoreBotMessageURl': 'soawebsocket.citi.com/Fusion',
      'taskBotId': 'st-e545489f-97f1-528b-baf1-f9a36517d9ee',
      'preLoginKoreTokenUrl': 'api/prelogin/digital/users/chatBot/koreServices/tokenAndUserInfo/retrieve',
      'bestbuyAccount': 'citicrsbbyprod',
      'thdAccount': 'citicrsthdprod',
      'specialtyAccount': 'citicrsrplallprod',
      'searsAccount': 'citicrssrsprod',
      'searsSYWAccount': 'citicrssywprod',
      'fuelsAccount': 'citicrsoilprod',
      'macysAccount': 'citicrsmcyprod',
      'llbeanAccount':'citicrsllbprod',
      'wayfairAccount': 'citicrswfrprod',
      'citipayAccount': 'citicrscitipayprod',
      'overstockAccount': 'citicrsoverstockprod',
      'dillardsAccount': 'citicrsrplallprod',
      'e2e/key' : 'public/v1/security/e2e/key',
      'e2eConfigUrl': 'api/prelogin/e2eConfig/client/fsvc',
      'logout': 'v1/user/auth/del',
      'tmxOrgId': '530q7tul'
    },
    channel: 'FUSION',
    tmtAppId: '166958-fsvc-websdk-nam'
  },

  businessIDMapping: [{
    PLCN_LLBEAN: 'LLBEAN',
    PLCN_MEIJER: 'MJ',
    PLCN_WFCC: 'WF',
    PLCN_OSTK: 'OS',
    PLCN_DILLARDS: 'DL',
    SEARS: 'CTY'
  }],

  logging: {
    "app.home.IndexComponent": "INFO"
  },

  sessionCookieInformation: {

    cookieName: 'NGACoExistenceCookie',
    valueSeparator: '|',
    headers: [
      {
        headerName: 'bizToken',
        headerValue: '[bizToken]'
      },
      {
        headerName: 'Authorization',
        headerValue: 'Bearer [authToken]'
      },
      {
        headerName: 'client_id',
        headerValue: '[clientId]'
      }
    ],
    isFriendKey: 'isFriend'
  },

  sessionService: {
    sessionTimeout: 300,
    keepAliveInterval: 10,
    sessionKeepAliveUrl: '/keepAlive'
  },

  httpService: {
    defaultHeaders: {
      'Content-Type': 'application/json'
    },
    headersToSendFromPreviousResponse: [
      {
        headerNameInPreviousResponse: 'CCPToken',
        headerNameToSendInRequest: 'CCPToken'
      }
    ]
  },

  contentService: {
    useHashForSC: true
  }

};
